import { ACTION_FETCH_USER_INFO } from '~/store/actionTypes';

/** @type {import('@nuxt/types').Middleware} */
const middleware = async function({ app, store }) {
    if (app.$tidalAuth.isLoggedIn()) {
        await store.dispatch(ACTION_FETCH_USER_INFO);
    }
};

export default middleware;
